import { ACTIVE_BRANCH_OFFICE_HEADER, getActiveBranchOfficeId } from './active-branch-office';
import { readSessionToken } from './session-token';

const buildAuthHeaders = (isAuth: boolean): Headers => {
  const headers = new Headers();
  const token = readSessionToken();
  headers.set('Accept', 'application/json');
  if (token && isAuth) {
    headers.set('Authorization', `Bearer ${token}`);

    const branchOfficeId = getActiveBranchOfficeId();
    if (branchOfficeId) {
      headers.set(ACTIVE_BRANCH_OFFICE_HEADER, branchOfficeId);
    }
  }

  return headers;
};

export const getRequestOptions = (isAuth = true): RequestInit => {
  const headers = buildAuthHeaders(isAuth);
  headers.set('Content-Type', 'application/json');

  return {
    headers,
  };
};

/**
 * Igual que getRequestOptions pero SIN Content-Type: el navegador debe fijar
 * `multipart/form-data` con su boundary al enviar un FormData.
 */
export const getMultipartRequestOptions = (isAuth = true): RequestInit => ({
  headers: buildAuthHeaders(isAuth),
});
